export default "__VITE_ASSET__adUZgwI4__"